import { IExpressionEvaluator } from "../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";
import { VarAssignExpression } from "../../Models/VarAssignExpression";

export class VarAssignExpressionEvaluator implements IExpressionEvaluator<VarAssignExpression> {
    get type(): string {
        return "VarAssign";
    }

    evaluate(expression: VarAssignExpression, context: IExpressionEvaluatorContext): MaybePromise {
        const value = context.Evaluator.evaluate(expression.Value, context);

        if (value instanceof Promise) {
            return value.then((resolved) => {
                context.Evaluator.assign(expression.Variable, context, resolved);
                return resolved;
            });
        }

        context.Evaluator.assign(expression.Variable, context, value);
        return value;
    }
}
